const squareRegular = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAmElEQVQ4je3UMQuCUBDA8b9xQZooEX0Egwx06fsvTk5SUENuQdAQ0ZIGPngNj5yvWhq86TjudzfdedZavg0BOmN2h/rRtEozDfwsTcYiAmz3x9P5ol94vd2ttZs8FaBpn0C2SuIo1OCirByRvhRH4WI+0+8HRh91D3jA/407Y/pcgMCfAEVZ6Uc4IkC+XvI+TKV0xPvlDb0AHdEtYDHDRQoAAAAASUVORK5CYII=';

export {
  squareRegular,
};
